import { twMerge } from "tailwind-merge";

export default function HomeIcon({ fill = "#808080", className, ...props }) {
  const defaultClasses = "w-4 h-4";
  const mergedClassName = twMerge(defaultClasses, className);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      className={mergedClassName}
      viewBox="0 0 123.61 109.04"
      {...props}
    >
      <path d="M118.49,62.44c-11.78-28.52-48.09-37.8-22.47-34.84-13.18-12.05-29.8-18.71-53.43-14.5-5.02-7.33-17.03-22.96-13.35-4.24,0,0-2.94-7.7-6.02-5.37s-.33,18.89-.33,18.89c-7.16,5.46-11.07,23.65-16.61,35.48-4.74,4.7-8.25,13.81-5.05,19.06,4.61,7.05,19.03,7.15,20.69-4.88,4.63,1.68,11.49-2.09,22-14.74,3.98,1.47,7.1,4.73,8.46,11.72,2.37,12.23-.9,20.42-5.87,30.76-.44.91,0,.03-.47.97h0c-.34.75-.53,1.56-.53,2.43,0,3.23,2.62,5.86,5.86,5.86h66.37c2.91,0,5.31-2.12,5.77-4.9.05-.31.09-.63.09-.96,0-.14-.01-.28-.02-.41,1.22-35.12-31.05-51.8-5.09-40.33Z" />
    </svg>
  );
}